import { SetStateAction, Dispatch } from "react";

import {
  checkYoutubeVideoUrlForPatternMatch,
  createYouTubeEmbedUrl,
} from "@every.org/common/src/helpers/socialNetworks";

import {
  DefaultCoverPreview,
  PhotoCoverPreview,
} from "src/components/CoverPhotoOrVideoPicker/PhotoCoverPreview";
import {
  YouTubeEmbed,
  YouTubeEmbedPlaceholder,
} from "src/components/CoverPhotoOrVideoPicker/YouTubeEmbed";
import {
  CoverPhotoOrVideoPickerProps,
  CoverOption,
} from "src/components/CoverPhotoOrVideoPicker/types";

export const PreviewCover = (
  props: CoverPhotoOrVideoPickerProps & {
    coverOption: CoverOption;
    setCoverOption: Dispatch<SetStateAction<CoverOption>>;
  }
) => {
  const { coverYoutubeVideoId } = props;
  const coverYoutubeVideoUrl = createYouTubeEmbedUrl(coverYoutubeVideoId);
  const invalidCoverYoutubeVideoUrl =
    !!coverYoutubeVideoUrl &&
    !checkYoutubeVideoUrlForPatternMatch(coverYoutubeVideoUrl);

  switch (props.coverOption) {
    case CoverOption.PHOTO:
      return <PhotoCoverPreview {...props} />;
    case CoverOption.VIDEO:
      if (!coverYoutubeVideoId || invalidCoverYoutubeVideoUrl) {
        return <YouTubeEmbedPlaceholder />;
      }
      return (
        <YouTubeEmbed
          videoId={coverYoutubeVideoId}
          onError={(errorMessage?: string) => {
            props.setValidationErrors((prev) => ({
              ...prev,
              coverYoutubeVideoUrl: errorMessage
                ? { message: errorMessage, success: false }
                : undefined,
            }));
          }}
        />
      );
    case CoverOption.DEFAULT:
      return <DefaultCoverPreview {...props} />;
  }
};
